export enum SlackChannels {
  OPS_INTRACTION_ERRORS = 'ops-intraction-errors',
  DEBUG = 'debug',
  OPS_INTRACTION_SENDGRID = 'ops-intraction-sendgrid',
  OPS_WHEREBY = 'ops-whereby'
}
